const {
  produce
} = require("immer");
const {
  getLocalItem,
  setLocalItem
} = require("../browserStorage");

let hostname = process.env.GATEWAY_HOST || "localhost";
let port = process.env.GATEWAY_PORT || "";
let protocol = process.env.GATEWAY_MODE || (global.location && global.location.protocol) || "http:"
let host = process.env.GATEWAY_URL || `${hostname}:${port}`

if (process.env.NODE_ENV !== "development" && global.location) {
  hostname = global.location.hostname || hostname
  port = global.location.port || port;
  host = global.location.host || `${hostname}:${port}`;
  protocol = global.location.protocol || protocol;
}

const initialState = {
  host,
  port,
  protocol,
  hostname,
  name: null,
  simtopyId: null,
  socket: {},
  socketConnected: false,
  socketConnectedAt: null,
  socketDisconnectedAt: null,
  unauthorized: false,
  simtopyList: [],
  notifications: getLocalItem("notifications") || [],
  openProjectUids: [],
  groups: [],
  platforms: [],
  apps: [],
  backgroundFile: null,
  logoFile: null,
  faviconFile: null,
  timeout: 5000,
  dataLoaded: false,
  filesURL: {},
  selectedTheme: getLocalItem("selectedTheme") || null,
  contactPageEnabled: false,
  presentationButtonEnabled: false,
  guestsEnabled: false,
  colorButtonOnProjectBar: null
}

/**
 * Top level Reducer
 */

module.exports = function (state = initialState, action) {
  switch (action.type) {
    /**
     * INIT
     */

    case "SOCKET_CONNECTION":
      return produce(state, draft => {
        draft.socket = action.socket
        draft.socketConnected = Boolean(action.socket?.connected)
        draft.socketConnectedAt = action.connectedAt
        draft.socketDisconnectedAt = action.disconnectedAt
      });

    case "SOCKET_UNAUTHORIZED":
      return produce(state, draft => {
        draft = initialState;
        draft.unauthorized = true;
      });

    case "SOCKET_DISCONNECTED":
    case "SOCKET_ERROR":
      return produce(state, draft => {
        draft.socketConnected = false
        draft.socketConnectedAt = action.connectedAt
        draft.socketDisconnectedAt = action.disconnectedAt
      });

    case "SET_INFO":
      return produce(state, draft => {
        draft.platforms = action.platforms
        draft.groups = action.groups
        draft.apps = action.apps
        draft.backgroundFile = action.backgroundFile
        draft.logoFile = action.logoFile
        draft.faviconFile = action.faviconFile
        draft.contactPageEnabled = action.contactPageEnabled
        draft.presentationButtonEnabled = action.presentationButtonEnabled
        draft.guestsEnabled = action.guestsEnabled
        draft.colorButtonOnProjectBar = action.colorButtonOnProjectBar
        if (action.themeUid) draft.selectedTheme = action.themeUid
      });

    // case "SET_SIMTOPY":
    //   return produce(state, draft => {
    //     Object.assign(draft, action.simtopy)
    //   });

    case "SET_TIMEOUT":
      return produce(state, draft => {
        draft.timeout = action.timeout
      });

    case "OPEN_PROJECT":
      return produce(state, draft => {
        if (!state.openProjectUids.includes(action.uid)) {
          draft.openProjectUids.push(action.uid)
        }
      })

    case 'CLOSE_PROJECT':
      return produce(state, draft => {
        draft.openProjectUids = state.openProjectUids.filter(uid => uid !== action.uid)
      });

    // Push string to array
    case "PUSH_NOTIFICATION":
      let date = new Date();
      let datetime = date.getHours() + ":" + date.getMinutes() +
        ":" + date.getSeconds() + " " + date.getDate() + "/" +
        (date.getMonth() + 1) + "/" + date.getFullYear();
      return produce(state, draft => {
        draft.notifications = [{
          date: datetime,
          msg: action.notif
        }, ...draft.notifications];
        setLocalItem("notifications", draft.notifications);
      });

    case "DATA_LOADED":
      return produce(state, draft => {
        draft.dataLoaded = true
      })

    case "SET_FILE_URL":
      return produce(state, draft => {
        draft.filesURL[action.uid] = {
          url: action.url,
          timestamp: action.timestamp
        }
      })

    case "DEL_FILE_URL":
      return produce(state, draft => {
        delete draft.filesURL[action.uid]
      })

    case "SELECT_THEME":
      return produce(state, draft => {
        draft.selectedTheme = action.selectedTheme
      })

    default:
      return state;
  }
};